import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import "rsuite/dist/rsuite-no-reset.min.css";
import "./Date.css";
import {
  addFilters,
  applyFilters,
  resetFilters,
} from "../../store/slices/FilterSliceServiceCollabax";
import ViMultiSelect from "../Multi-Select-Dropdown/ViMultiSelectDropdownServiceCollabax";
import { useQuery } from "@tanstack/react-query";
import {
  fetchRegion,
  fetchStates,
  fetchStatesOffice,
  fetchRsm,
  fetchDealer,
  fetchDealercode,
  fetchDivision,
  fetchProductLine,
  fetchLOB,
  fetchPartnerType,
  fetchDealerTag,
  fetchPPL,
  fetchPL,
  reducer,
} from "./apiServiceCollabax";

export default function ServiceCollabaxFilter({
  fields,
  filtermodal,
  onExport,
}) {
  const { data, submitted } = useSelector(
    (state) => state.filtersServiceCollabax,
  );

  const { data: newdata } = useSelector((state) => state.forms);

  const {
    region: pRegion,
    state: pState,
    state_office: pStateOffice,
    Rsm_Name: pRsm,
    Partner_Type: pPartnerType,
    dealer_tag: pDealerTag,
    dealer_name: pDealer,
    dealer_code: pDealerCode,
    division_name: pDivision,
    Product_Line: pProductLine,
    lob: pLob,
    ppl: pPpl,
    pl: pPl,
  } = data;

  const dispatch = useDispatch();
  const [clicked, setClicked] = useState(1);
  const [selectedRegion, setSelectedRegion] = useState([]);
  const [selectedState, setSelectedState] = useState([]);
  const [selectedStateOffice, setSelectedStateOffice] = useState([]);
  const [selectedRsm, setSelectedRsm] = useState([]);
  const [selectedPartnerType, setSelectedPartnerType] = useState([]);
  const [selectedDealerTag, setSelectedDealerTag] = useState([]);
  const [selectedDealer, setSelectedDealer] = useState([]);
  const [selectedDealerCode, setSelectedDealerCode] = useState([]);
  const [selectedDivision, setSelectedDivision] = useState([]);
  const [selectedProductLine, setSelectedProductLine] = useState([]);
  const [selectedLob, setSelectedLOB] = useState([]);
  const [selectedPpl, setSelectedPPL] = useState([]);
  const [selectedPl, setSelectedPL] = useState([]);

  const { data: regions, isLoading: rL } = useQuery({
    queryKey: ["ServiceCollabax", "region", submitted],
    queryFn: () => fetchRegion(),
    initialData: [],
  });

  const { data: states, isLoading: sL } = useQuery({
    queryKey: ["ServiceCollabax", "states", submitted, pRegion],
    queryFn: () => fetchStates(pRegion),
    initialData: [],
  });

  const { data: statesoffice, isLoading: soL } = useQuery({
    queryKey: ["ServiceCollabax", "statesoffice", submitted, pRegion, pState],
    queryFn: () => fetchStatesOffice(pRegion, pState),
    initialData: [],
  });

  const { data: rsm, isLoading: rsmL } = useQuery({
    queryKey: [
      "ServiceCollabax",
      "rsm",
      submitted,
      pRegion,
      pState,
      pStateOffice,
    ],
    queryFn: () => fetchRsm(pRegion, pState, pStateOffice),
    initialData: [],
  });

  const { data: PartnerType, isLoading: poL } = useQuery({
    queryKey: [
      "ServiceCollabax",
      "PartnerType",
      submitted,
      pRegion,
      pState,
      pStateOffice,
      pRsm,
    ],
    queryFn: () => fetchPartnerType(pRegion, pState, pStateOffice, pRsm),
    initialData: [],
  });

  const { data: dealerTag, isLoading: dtL } = useQuery({
    queryKey: [
      "ServiceCollabax",
      "dealerTag",
      submitted,
      pRegion,
      pState,
      pStateOffice,
      pRsm,
      pPartnerType,
    ],
    queryFn: () =>
      fetchDealerTag(pRegion, pState, pStateOffice, pRsm, pPartnerType),
    initialData: [],
  });

  const { data: dealer, isLoading: dL } = useQuery({
    queryKey: [
      "ServiceCollabax",
      "dealer",
      submitted,
      pRegion,
      pState,
      pStateOffice,
      pRsm,
      pPartnerType,
      pDealerTag,
    ],
    queryFn: () =>
      fetchDealer(
        pRegion,
        pState,
        pStateOffice,
        pRsm,
        pPartnerType,
        pDealerTag,
      ),
    initialData: [],
  });

  const { data: dealercode, isLoading: dcL } = useQuery({
    queryKey: [
      "ServiceCollabax",
      "dealercode",
      submitted,
      pRegion,
      pState,
      pStateOffice,
      pRsm,
      pPartnerType,
      pDealerTag,
      pDealer,
    ],
    queryFn: () =>
      fetchDealercode(
        pRegion,
        pState,
        pStateOffice,
        pRsm,
        pPartnerType,
        pDealerTag,
        pDealer,
      ),
    initialData: [],
  });

  const { data: division, isLoading: diL } = useQuery({
    queryKey: [
      "ServiceCollabax",
      "division",
      submitted,
      pRegion,
      pState,
      pStateOffice,
      pRsm,
      pPartnerType,
      pDealerTag,
      pDealer,
      pDealerCode,
    ],
    queryFn: () =>
      fetchDivision(
        pRegion,
        pState,
        pStateOffice,
        pRsm,
        pPartnerType,
        pDealerTag,
        pDealer,
        pDealerCode,
      ),
    initialData: [],
  });

  const { data: productLine, isLoading: plL } = useQuery({
    queryKey: [
      "ServiceCollabax",
      "productLine",
      submitted,
      pRegion,
      pState,
      pStateOffice,
      pRsm,
      pPartnerType,
      pDealerTag,
      pDealer,
      pDealerCode,
      pDivision,
    ],
    queryFn: () =>
      fetchProductLine(
        pRegion,
        pState,
        pStateOffice,
        pRsm,
        pPartnerType,
        pDealerTag,
        pDealer,
        pDealerCode,
        pDivision,
      ),
    initialData: [],
  });

  const { data: lob, isLoading: lobL } = useQuery({
    queryKey: [
      "ServiceCollabax",
      "lob",
      submitted,
      pRegion,
      pState,
      pStateOffice,
      pRsm,
      pPartnerType,
      pDealerTag,
      pDealer,
      pDealerCode,
      pDivision,
      pProductLine,
    ],
    queryFn: () =>
      fetchLOB(
        pRegion,
        pState,
        pStateOffice,
        pRsm,
        pPartnerType,
        pDealerTag,
        pDealer,
        pDealerCode,
        pDivision,
        pProductLine,
      ),
    initialData: [],
  });

  const { data: ppl, isLoading: pplL } = useQuery({
    queryKey: [
      "ServiceCollabax",
      "ppl",
      submitted,
      pRegion,
      pState,
      pStateOffice,
      pRsm,
      pPartnerType,
      pDealerTag,
      pDealer,
      pDealerCode,
      pDivision,
      pProductLine,
      pLob,
    ],
    queryFn: () =>
      fetchPPL(
        pRegion,
        pState,
        pStateOffice,
        pRsm,
        pPartnerType,
        pDealerTag,
        pDealer,
        pDealerCode,
        pDivision,
        pProductLine,
        pLob,
      ),
    initialData: [],
  });

  const { data: pl, isLoading: plL1 } = useQuery({
    queryKey: [
      "ServiceCollabax",
      "pl",
      submitted,
      pRegion,
      pState,
      pStateOffice,
      pRsm,
      pPartnerType,
      pDealerTag,
      pDealer,
      pDealerCode,
      pDivision,
      pProductLine,
      pLob,
      pPpl,
    ],
    queryFn: () =>
      fetchPL(
        pRegion,
        pState,
        pStateOffice,
        pRsm,
        pPartnerType,
        pDealerTag,
        pDealer,
        pDealerCode,
        pDivision,
        pProductLine,
        pLob,
        pPpl,
      ),
    initialData: [],
  });

  async function handleSearch() {
    let userSelectedFilter = {
      data: {
        region: pRegion || selectedRegion,
        state: pState || selectedState,
        state_office: pStateOffice || selectedStateOffice,
        Rsm_Name: pRsm || selectedRsm,
        Partner_Type: pPartnerType || selectedPartnerType,
        dealer_tag: pDealerTag || selectedDealerTag,
        dealer_name: pDealer || selectedDealer,
        dealer_code: pDealerCode || selectedDealerCode,
        division_name: pDivision || selectedDivision,
        Product_Line: pProductLine || selectedProductLine,
        lob: pLob || selectedLob,
        ppl: pPpl || selectedPpl,
        pl: pPl || selectedPl,
      },
      submitted: clicked + 1,
    };

    dispatch(addFilters(userSelectedFilter));
    setClicked((prev) => prev + 1);
  }

  const handleRefresh = () => {
    if (fields) {
      dispatch(resetFilters());
    } else {
      window.location.reload();
    }
  };

  return (
    <section>
      <div className="flex gap-2 border-[#2c8a8b] border rounded-md p-2">
        {/* ── Filters grid ── */}
        <div className="">
          <div className="grid grid-cols-3 gap-2 md:gap-2 lg:grid-cols-[repeat(14,minmax(0,1fr))] md:grid-cols-6">
            <div className={divStyle}>
              <label className={labelStyle}>Region</label>
              <ViMultiSelect
                options={regions}
                onSelectionChange={setSelectedRegion}
                opnsSelected={pRegion}
                keey="region"
                isLoading={rL}
              />
            </div>

            {(!fields || fields.includes("State")) && (
              <div className={divStyle}>
                <label className={labelStyle}>State</label>
                <ViMultiSelect
                  options={states}
                  onSelectionChange={setSelectedState}
                  opnsSelected={pState}
                  keey="state"
                  isLoading={sL}
                />
              </div>
            )}

            {(!fields || fields.includes("State Office")) && (
              <div className={divStyle}>
                <label className={labelStyle}>State Office</label>
                <ViMultiSelect
                  options={statesoffice}
                  onSelectionChange={setSelectedStateOffice}
                  opnsSelected={pStateOffice}
                  keey="state_office"
                  isLoading={soL}
                />
              </div>
            )}
            {(!fields || fields.includes("RSM")) && (
              <div className={divStyle}>
                <label className={labelStyle}>RSM</label>
                <ViMultiSelect
                  options={rsm}
                  onSelectionChange={setSelectedRsm}
                  opnsSelected={pRsm}
                  keey="rsm"
                  isLoading={rsmL}
                />
              </div>
            )}
            {(!fields || fields.includes("Partner Type")) && (
              <div className={divStyle}>
                <label className={labelStyle}>Partner Type</label>
                <ViMultiSelect
                  options={PartnerType}
                  onSelectionChange={setSelectedPartnerType}
                  opnsSelected={pPartnerType}
                  keey="Partner_Type"
                  isLoading={poL}
                />
              </div>
            )}
            {(!fields || fields.includes("Category")) && (
              <div className={divStyle}>
                <label className={labelStyle}>Category</label>
                <ViMultiSelect
                  options={dealerTag}
                  onSelectionChange={setSelectedDealerTag}
                  opnsSelected={pDealerTag}
                  keey="dealer_tag"
                  isLoading={dtL}
                />
              </div>
            )}

            {(!fields || fields.includes("Dealer Name")) && (
              <div className={divStyle}>
                <label className={labelStyle}>Dealer Name</label>
                <ViMultiSelect
                  options={dealer}
                  onSelectionChange={setSelectedDealer}
                  opnsSelected={pDealer}
                  keey="dealer_name"
                  isLoading={dL}
                />
              </div>
            )}

            {(!fields || fields.includes("Dealer Code")) && (
              <div className={divStyle}>
                <label className={labelStyle}>Dealer Code</label>
                <ViMultiSelect
                  options={dealercode}
                  onSelectionChange={setSelectedDealerCode}
                  opnsSelected={pDealerCode}
                  keey="dealer_code"
                  isLoading={dcL}
                />
              </div>
            )}

            {(!fields || fields.includes("Division")) && (
              <div className={divStyle}>
                <label className={labelStyle}>Division</label>
                <ViMultiSelect
                  options={division}
                  onSelectionChange={setSelectedDivision}
                  opnsSelected={pDivision}
                  keey="division_name"
                  isLoading={diL}
                />
              </div>
            )}

            {(!fields || fields.includes("Product Line")) && (
              <div className={divStyle}>
                <label className={labelStyle}>Product Line</label>
                <ViMultiSelect
                  options={productLine}
                  onSelectionChange={setSelectedProductLine}
                  opnsSelected={pProductLine}
                  keey="Product_Line"
                  isLoading={plL}
                />
              </div>
            )}

            {(!fields || fields.includes("LOB")) && (
              <div className={divStyle}>
                <label className={labelStyle}>LOB</label>
                <ViMultiSelect
                  options={lob}
                  onSelectionChange={setSelectedLOB}
                  opnsSelected={pLob}
                  keey="lob"
                  isLoading={lobL}
                />
              </div>
            )}
            {(!fields || fields.includes("PPL")) && (
              <div className={divStyle}>
                <label className={labelStyle}>PPL</label>
                <ViMultiSelect
                  options={ppl}
                  onSelectionChange={setSelectedPPL}
                  opnsSelected={pPpl}
                  keey="ppl"
                  isLoading={pplL}
                />
              </div>
            )}

            <div className={divStyle}>
              <label className={labelStyle}>PL</label>
              <ViMultiSelect
                options={pl}
                onSelectionChange={setSelectedPL}
                opnsSelected={pPl}
                keey="pl"
                isLoading={plL1}
              />
            </div>
            <div className="flex items-end  md:items-center justify-normal md:justify-end gap-2 w-full md:flex-col mt-1">
              <div>
                <button
                  className="text-white w-full rounded-sm bg-[#2A5775] px-5"
                  type="button"
                  onClick={handleSearch}
                >
                  Apply
                </button>
              </div>
              <div>
                <button
                  className="text-white w-full rounded-sm bg-[#2A5775] px-5"
                  onClick={handleRefresh}
                >
                  Reset
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

const divStyle = "flex flex-col justify-center";
const labelStyle =
  "font-semibold py-1 text-xs text-[#2A5775] whitespace-nowrap";
